import React , { useState , useEffect } from 'react';
import webapi from '../../../api/webapi';
import Modal from 'react-bootstrap/Modal'

var isTouched = false;
var touchStartTime = 0;
var doubleClickThreshold = 300;

const SurfResultparagraphList = (props) => { 

    const [modalText,setModalText] = useState('')
    const [modalshow,setModalshow] = useState(false)
    const [modalHeader,setModalHeader] = useState(undefined)

    const handleTouchStart = (event) => {
        if (isTouched === false){
            isTouched = true;
            touchStartTime= Date.now();
            //console.log('isTouched1: true')
        }else{
            if (Date.now() - touchStartTime <= doubleClickThreshold) {
                isTouched = false;
                //console.log('isTouched2: false')
            }else{
                isTouched = true;
                touchStartTime= Date.now();
                //console.log('isTouched3: true');
            }
        }        
    };
    
    const handleTouchEnd = (event) => {
        //console.log('isTouched4:',isTouched)
        if (isTouched === false){
            //console.log('isTouched5:',Date.now() - touchStartTime)
            if (Date.now() - touchStartTime <= doubleClickThreshold) {
                //console.log('Double click detected!');
                showModal(event);
            }
        }
    };

    const getTextCode = (paragraphCode) => {
        if (window.getSelection)
        {
            let selection = window.getSelection ();
            
            var start = selection.anchorOffset;
            //console.log('start:',start)
            var end = selection.focusOffset;
            //console.log('end:',end)

            setModalHeader(selection.anchorNode.textContent.substring(start,end));

            var s = selection.anchorNode.textContent.substring(0,start);
            
            var Sequence = ('000'+(s.length - s.replaceAll(" ", "").length + 1));
            Sequence=Sequence.substring(Sequence.length-3,Sequence.length) 
            
            var TextCode = paragraphCode+Sequence
            
            //console.log(TextCode);
            return TextCode;
        }
    }

    const showModal = async event => {
        event.preventDefault();
        
        //console.log('showModalPcode:',event.target.getAttribute('paragraphcode'))
        var TextCode=getTextCode(event.target.getAttribute('paragraphcode'));
        if (!modalshow)
        {
            await webapi.get('sentence/detail/'+TextCode)
                .then((res) =>{
                    if (res.data) {
                        setModalText(res.data);
                        console.log('res.data:',res.data)
                        if (res.data!=='')
                            setModalshow(true);
                    }
                } )
            
            
        }
        else
        {
            setModalshow(false);
            setModalText('');
        }
    };

    // const CloseModal = event => {
    //     event.preventDefault();
    //     setModalshow(false);
    // }

    
    return (
        <div>
            <div className="alert" role="alert">
                {props.pageData.length!==0 && props.pageData[0].F29905!== undefined?props.pageData[0].F29905:29905/*"برای مشاهده برچسب‌های واژه روی شماره کلیک کنید"*/}
            </div>
            {
                props.paragraphList.map((paragraph) =>{
                return  (
                        <div className="container-fluid" id="texts_main_content" key={paragraph.Code}>
                            <div className="container">
                                <div id="texts_main_content_body">
                                    {
                                        (paragraph.Text)
                                        ?
                                        paragraph.Text.map((TextSection,i) =>{
                                            //console.log(TextSection);
                                        return  (
                                            props.selectedBookGroup==='5'
                                            ?
                                            <p className="right_align_manavi" key={'ch1i'+i+'pc'+paragraph.Code} ParagraphCode={paragraph.Code} onDoubleClick={showModal} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                                                {TextSection.Section}
                                            </p>
                                            :
                                            <p className="right_align_pahlavi" key={'ch1i'+i+'pc'+paragraph.Code} paragraphcode={paragraph.Code} onDoubleClick={showModal} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                                                {TextSection.Section}
                                            </p>
                                        )
                                        })
                                        :
                                        null
                                    }
                                    {
                                        (paragraph.Transcription)
                                        ?
                                        paragraph.Transcription.map((TranscriptionSection,i) =>{
                                        return  (
                                                    <p className="left_align" key={'ch2i'+i+'pc'+paragraph.Code} paragraphcode={paragraph.Code} onDoubleClick={showModal}>
                                                        {paragraph.Sequence}- {TranscriptionSection.Section}
                                                    </p>
                                                )
                                        })
                                        :
                                        null
                                    }
                                    {
                                        (paragraph.Translation)
                                        ?
                                        paragraph.Translation.map((TranslationSection,i) =>{
                                        return  (
                                                    <p className="right_align" key={'ch3i'+i+'pc'+paragraph.Code} style={{fontFamily:"Tahoma",fontSize:"13px"}}>
                                                        {TranslationSection.Section}
                                                    </p>
                                                )
                                        })
                                        :
                                        null
                                    }
                                    {
                                        (paragraph.EnTranslation)
                                        ?
                                        paragraph.EnTranslation.map((EnTranslationSection,i) =>{
                                        return  (
                                                    <p className="left_align" key={'ch4i'+i+'pc'+paragraph.Code} style={{fontFamily:"Tahoma",fontSize:"13px"}}>
                                                        {EnTranslationSection.Section}
                                                    </p>
                                                )
                                        })
                                        :
                                        null
                                    }
                                    {
                                        (paragraph.Note!=="")
                                        ?
                                        <p id="texts_Note_content_body">
                                            {paragraph.Note}
                                        </p>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            {
                (modalText && modalshow === true) 
                ?
                (
                    <Modal
                        show={modalshow}
                        onHide={() => setModalshow(false)}
                        dialogClassName="modal-90w"
                        aria-labelledby="modal-styling-title"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="modal-styling-title">
                                
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <table id=''>
                                <tbody>
                                <tr>
                                        <td>
                                            <div className="Caption">Word:</div>
                                        </td>
                                        <td>
                                            {
                                                props.selectedBookGroup==="5"
                                                ?
                                                <div className="rtlDataManavi">{modalText.Word}</div>
                                                :
                                                <div className="rtlDataPahlavi">{modalText.Word}</div>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="Caption">Transcription:</div>
                                        </td>
                                        <td>
                                            <div className="ltrData">{modalText.Transcription}</div>
                                            </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="Caption">Transliteration:</div>
                                        </td>
                                        <td>
                                            <div className="ltrData">{modalText.Transliteration}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="Caption">Translation1:</div>
                                        </td>    
                                        <td>    
                                            <div className="ltrDataFa">{modalText.Translation}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="Caption">Translation2:</div>
                                        </td>    
                                        <td>    
                                            <div className="ltrDataFa">{modalText.EnTranslation}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="Caption">Category:</div>
                                        </td>    
                                        <td>   
                                            <div className="ltrDataFa">{modalText.Category}</div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="Caption">Lemma:</div>
                                        </td>    
                                        <td>    
                                            <div className="ltrData">{modalText.Lemma}</div>
                                        </td>
                                    </tr>
                                    <tr> 
                                        <td>
                                            <div className="Caption">Reference1:</div>
                                        </td>    
                                        <td>    
                                            <div className="ltrData">{modalText.Reference1}</div>
                                        </td>
                                    </tr>
                                    <tr>   
                                        <td>
                                            <div className="Caption">Reference2:</div>
                                        </td>    
                                        <td>     
                                            <div className="ltrData">{modalText.Reference2}</div>
                                        </td>
                                    </tr>
                                    <tr>   
                                        <td>
                                            <div className="Caption">Note:</div>
                                        </td>    
                                        <td>     
                                            <div className="ltrData">{modalText.Note}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Modal.Body>
                    </Modal>
                )
                :
                <></>
            }
        </div>
    )
}

export default SurfResultparagraphList;